export function partnersFlicking() {
    if (!!document.querySelector('#partners-flick') === false) return;
    const flicking = new Flicking('#partners-flick', {
        circular: true,
        align: 'center',
        inputType: ['pointer'],
    });
    flicking.addPlugins(new Flicking.Plugins.AutoPlay());
}
